import ApiClient from '@/api/client';

const DATASTORES_API_PATH = '/{0}/datastores/';

class DatastoreAPI extends ApiClient {

  constructor() {
    super();
  }

  /** GET */
  async getDatastoreList(datastoreType) {
    const route = `${DATASTORES_API_PATH.format(datastoreType)}databases/`;
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async getTablesList(tableUrl) {
    const response = await this.get(`${tableUrl}?free=true`);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  /** CREATE */
  async createDatastore(datastoreType, data) {
    const route = `${DATASTORES_API_PATH.format(datastoreType.type)}${datastoreType.value}/`;
    const response = await this.post(route, data);
    if (response.status === 201) {
      return response.data;
    }
    return false;
  }
  async createDatastoreResource(id, datastoreType, data, async = true) {
    const route = `${DATASTORES_API_PATH.format(datastoreType.type)}${datastoreType.value}/${id}/?asynchrone=${async}`;
    const response = await this.patch(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  /** UPDATE */
  async updateDatastore(resourceId, datastoreType, data) {
    const route = `${DATASTORES_API_PATH.format(datastoreType.type)}${datastoreType.value}/${resourceId}/`;
    const response = await this.put(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async updateDatastoreResource(id, datastoreType, data, async = true) {
    const route = `${DATASTORES_API_PATH.format(datastoreType.type)}${datastoreType.value}/${id}/?asynchrone=${async}`;
    const response = await this.patch(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  /** SCENARII */
  async getDatastoreResourceScenarios(datastoreType, id) {
    const route = `${DATASTORES_API_PATH.format(datastoreType.type)}${datastoreType.value}/${id}/_scenarios/`;
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async runDatastoreResourceScenario(datastoreType, id, scenarioId, data) {
    const route =
      `${DATASTORES_API_PATH.format(datastoreType.type)}${datastoreType.value}/${id}/_scenarios/${scenarioId}/run/?asynchrone=true`;
    const response = await this.post(route, data);
    if (response.status === 202) {
      return response.data;
    }
    return false;
  }
};

const datastoreAPI = new DatastoreAPI();
export default datastoreAPI;